module.exports = __webpack_public_path__ + "static/media/expBlue.378f51cb.svg";